import { render, staticRenderFns } from "./_convoId.vue?vue&type=template&id=d65e2e8e&scoped=true&"
import script from "./_convoId.vue?vue&type=script&lang=js&"
export * from "./_convoId.vue?vue&type=script&lang=js&"
import style0 from "./_convoId.vue?vue&type=style&index=0&id=d65e2e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65e2e8e",
  null
  
)

export default component.exports